/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useCombineMotionValues as t}from"./use-combine-values.js";import{isMotionValue as o}from"./utils/is-motion-value.js";function e(e,...n){const r=e.length;return t(n.filter(o),(function(){let t="";for(let i=0;i<r;i++){t+=e[i];const r=n[i];r&&(t+=o(r)?r.get():r)}return t}))}export{e as useMotionTemplate};
//# sourceMappingURL=use-motion-template.js.map
